module.exports = __webpack_public_path__ + "static/006-5d0633be2fb6e42264551a0817f68114.jpg";